module.exports = __webpack_public_path__ + "img/report-cover-hero.e3e99bff.jpg";